import reactComponentLoader from 'scripts/react-component-loader'

import SearchInterestServiceContainer from './SearchInterestServiceContainer'

reactComponentLoader(SearchInterestServiceContainer, '[data-app-search-interest-service]')
